var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"how-to-play"},[(_vm.isLoadingScreen)?_c('LoadingCommon'):[_c('Title'),_c('Content',{attrs:{"length":_vm.listNumber.length}}),_c('Games',{attrs:{"listNumber":_vm.listNumber}})]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }